module.exports = __webpack_public_path__ + "static/media/trivia-desktop.290ebf8d.PNG";